import type { RefObject } from "react";
import Ctas from "@/components/ctas.tsx";
import { Overlay } from "@/components/ui/overlay.tsx";
import ConfigurationPanel from "@/features/sub-families/configuration-panel.tsx";
import type { Nullable } from "@/types";

type Props = { panelRef: RefObject<Nullable<HTMLDivElement>> };
export default function Configurator({ panelRef }: Props) {
    return (
        <Overlay className="configuration-panel">
            <div className="configuration-panel__scrollarea">
                <ConfigurationPanel panelRef={panelRef} />
                <Ctas />
            </div>
        </Overlay>
    );
}
